import React, { Component } from "react";
import { connect } from "react-redux";
import { bool, func, shape } from "prop-types";
import { actions as echeckActions, types } from "reducers/echecks";
import { Field, Form, withFormik } from "formik";
import { compose } from "redux";
import Button from "pages/_components/Button";
import * as i18n from "util/i18n";
import SelectorInput from "pages/_components/fields/formik/SelectorInput";
import { documentTypeFormats } from "util/format";
import Avatar from "pages/_components/Avatar";
import { string } from "yup/lib/locale";
import CustomData from "pages/_components/CustomData/CustomData";
import GridTable from "pages/_components/GridTable/GridTable";

class SearchBeneficiary extends Component {
    static propTypes = {
        handleSubmit: func.isRequired,
        values: shape({}).isRequired,
        setValues: func.isRequired,
        isSubmitting: bool.isRequired,
        setOpenSidebarForm: func.isRequired,
        beneficiary: shape({
            document: string,
            reference: string,
        }),
        dispatch: func.isRequired,
    };

    static defaultProps = {
        beneficiary: {},
    };

    render() {
        const { handleSubmit, values, setValues, isSubmitting, beneficiary, dispatch, setOpenSidebarForm } = this.props;
        const avalCaracter = i18n.get(`forms.inputFile.massivePayments.total`);
        return (
            <Form
                className="w-full flex flex-col beneficiaries"
                onSubmit={(e) => {
                    handleSubmit(e, setOpenSidebarForm);
                    e.stopPropagation();
                }}>
                <GridTable.Container columns={12} columnsTemplate="fixed">
                    <GridTable.Data columnStart={1} columnWidth={9}>
                        <Field
                            component={SelectorInput}
                            name="document"
                            hidePlaceholder
                            selectProps={{
                                name: "documentType",
                                value: {
                                    value: values.type,
                                    label: values.type,
                                } /* values.documentType */,
                                options: [
                                    { value: "CUIT", label: "CUIT" },
                                    { value: "CUIL", label: "CUIL" },
                                    { value: "CDI", label: "CDI" },
                                ],
                            }}
                            isFocused
                            label={i18n.get(`echecks.document.aval`)}
                            inputProps={{
                                name: "document",
                                value: values.document,
                                inputmode: "numeric",
                            }}
                            onChange={(type, stringDocument) => {
                                setValues({
                                    ...values,
                                    type: type?.value ? type.value : type,
                                    document: stringDocument,
                                });
                            }}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={10} columnWidth={3}>
                        <div className="form-group hidden-label">
                            <div className="button-group">
                                <Button
                                    type="submit"
                                    className="btn-outline"
                                    label="forms.bankselector.search"
                                    loading={isSubmitting}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleSubmit(e);
                                        e.stopPropagation();
                                    }}
                                    disabled={beneficiary?.reference}
                                />
                            </div>
                        </div>
                    </GridTable.Data>
                </GridTable.Container>
                {beneficiary?.reference && (
                    <>
                        <GridTable.Container columnsTemplate="fixed">
                            <GridTable.Data columnStart={1} columnWidth={12} flexDirection="column">
                                <GridTable.Container
                                    className="beneficiary box border blocktag mb-4"
                                    columns={12}
                                    columnsTemplate="fixed">
                                    <GridTable.Data
                                        columnStart={1}
                                        columnWidth={1}
                                        alignX="center"
                                        flexDirection="column">
                                        <Avatar
                                            user={{
                                                userFullName: beneficiary?.reference,
                                                defaultAvatarId: 0,
                                                email: beneficiary?.email,
                                            }}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data
                                        columnStart={2}
                                        columnWidth={9}
                                        alignX="center"
                                        flexDirection="column"
                                        className="two-column-beneficiary-data">
                                        <span>{`${beneficiary?.reference}`}</span>
                                        <CustomData
                                            titleText="echek.aval.caracter"
                                            titleTextType="I18N"
                                            valueText={avalCaracter}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={11} columnWidth={2} className="close" alignX="right">
                                        <Button
                                            onClick={() =>
                                                dispatch(echeckActions.beneficiaryEcheq({}, types.SELECT_BENEFICIARY))
                                            }
                                            image="images/figma/icon/cross.svg"
                                            bsStyle="link"
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>
                        </GridTable.Container>
                    </>
                )}
            </Form>
        );
    }
}

export default compose(
    connect(),
    withFormik({
        mapPropsToValues: () => ({
            type: "CUIT",
            document: "",
        }),
        handleSubmit: (form, formikBag) => {
            const { setSubmitting, setErrors, resetForm } = formikBag;
            const { dispatch, type, setOpenSidebarForm } = formikBag.props;

            if (form.document === "") {
                setErrors({
                    document: i18n.get("global.error.required"),
                });
                setSubmitting(false);
            } else if (documentTypeFormats(form.type, form.document)) {
                setSubmitting(true);
                dispatch(
                    echeckActions.bankedBeneficiary(
                        form,
                        setSubmitting,
                        type,
                        setErrors,
                        setOpenSidebarForm,
                        resetForm,
                    ),
                );
            } else {
                setErrors({
                    document: i18n.get("global.incorrect.format"),
                });
                setSubmitting(false);
            }
        },
    }),
)(SearchBeneficiary);
